import { render, staticRenderFns } from "./CoursesMobile.vue?vue&type=template&id=1c4cff01&scoped=true"
import script from "./CoursesMobile.vue?vue&type=script&lang=js"
export * from "./CoursesMobile.vue?vue&type=script&lang=js"
import style0 from "./CoursesMobile.vue?vue&type=style&index=0&id=1c4cff01&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4cff01",
  null
  
)

export default component.exports